import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Container,
  Avatar,
  Badge,
  Typography,
  Snackbar,
  Input,
  colors
} from '@material-ui/core';
import { getUser } from 'src/utils/Common';
import logo from 'src/assets/images/konsep_2.jpg';
import avatar from 'src/assets/images/technician.png';

import { saveFotograf, base64Reader } from 'src/utils/storage/StrPhoto';

import { isProduction } from 'src/utils/contants';
import axios from 'src/utils/axios';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
const useStyles = makeStyles((theme) => ({
  root: {},
  cover: {
    position: 'relative',
    height: 200,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    '&:before': {
      position: 'absolute',
      content: '" "',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundImage: 'linear-gradient(-180deg, rgba(0,0,0,0.00) 58%, rgba(0,0,0,0.32) 100%)'
    },
    '&:hover': {
      '& $changeButton': {
        visibility: 'visible'
      }
    }
  },
  changeButton: {
    visibility: 'hidden',
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    backgroundColor: colors.blueGrey[900],
    color: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(3),
      bottom: 'auto'
    },
    '&:hover': {
      backgroundColor: colors.blueGrey[900]
    }
  },
  addPhotoIcon: {
    bottom:0,
    right: 0,
    cursor: 'pointer'
  }, 
  addPhotoInput: {
    display: 'none'
  },
  container: {
    padding: theme.spacing(2, 3),
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  avatar: {
    border: `2px solid ${theme.palette.common.white}`,
    height: 120,
    width: 120,  
  },
  avatarDiv: {
    top: -60,
    left: theme.spacing(0),
    position: 'absolute'
  },
  details: {
    marginLeft: 136
  },
  actions: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1)
    },
    '& > * + *': {
      marginLeft: theme.spacing(1)
    }
  },
  pendingButton: {
    color: theme.palette.common.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  },
  personAddIcon: {
    marginRight: theme.spacing(1)
  },
  mailIcon: {
    marginRight: theme.spacing(1)
  }
}));

function Header({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const user = {
    name: `${SessionUser.FirstName} ${SessionUser.LastName}`,
    bio: `${SessionUser.ServiceShopCode} ${SessionUser.ServiceShopName}`,
    avatar: process.env.REACT_APP_ORTAM !== 'Production' ? avatar : `https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/${SessionUser.TechnicianId}.png`,
    cover: logo,
    connectedStatus: 'not_connected',
    Message: SessionUser.Message
  };
  const [UserImageUrl, setUserImageUrl] = useState(!isProduction ? avatar : `https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/${SessionUser.TechnicianId}.png`);

  const [connectedStatus] = useState(user.connectedStatus);
  const [openSnackbar, setOpenSnackbar] = useState(false);


  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (connectedStatus === 'pending') {
      setOpenSnackbar(true);
    }
  }, [connectedStatus]);
  
  useEffect(() => {
    GetSiriusUserImage();
  }, [SessionUser.TechnicianId]);

  const handleChangeImage = async (e) => {
    var file = e.target.files[0];
    let base64Result = '';
    base64Result = await base64Reader(file);
 
    const data = {
      Title: "SiriusUserImage",
      MIMEType: file.type,
      WorkOrderId: SessionUser.TechnicianId.toString(),
      FileType: "1",
      FileData: base64Result
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    await axios.post('/FileImportExport/SiriusFileUpload', data, config)
      // eslint-disable-next-line
      .then(response => {
        GetSiriusUserImage();
      }).catch((error) => {
        // saveFotograf(ReceiptNo, dataUri, DosyaTipi, DosyaTipiText, FileType);

      });



  }


  const GetSiriusUserImage = () => {
    const config = {
      responseType: 'blob',
    };

    axios.get(`/FileImportExport/SiriusUserImageDetail/${SessionUser.TechnicianId}`, config)
      .then((response) => {
        // openBlob(response.data, dosya.FileName);
        const fileURL = URL.createObjectURL(response.data);
        setUserImageUrl(fileURL);


      }).catch((error) => {

      });


  }
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div
        className={classes.cover}
        style={{ backgroundImage: `url(${user.cover})` }}
      />
      <Container
        maxWidth="lg"
        className={classes.container}
      >
       <label htmlFor="contained-button-file">
          <Input accept="image/*" className={classes.addPhotoInput}
            onChange={(e) => handleChangeImage(e)}
            id="contained-button-file" multiple type="file" />
          <div className={classes.avatarDiv}>
            <Badge
              overlap="circular"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              classes={{badge: classes.addPhotoIcon}}
              badgeContent={
                <AddAPhotoIcon/>
              }
            >
              <Avatar
                alt="Person"
                className={classes.avatar}
                src={UserImageUrl} />
            </Badge>
          </div>

        </label>
        <div className={classes.details}>
          <Typography
            component="h2"
            gutterBottom
            variant="overline"
          >
            {user.bio}
          </Typography>
          <Typography
            component="h1"
            variant="h4"
          >
            {user.name}
          </Typography>
        </div>

      </Container>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        autoHideDuration={6000}
        message={(
          <Typography
            color="inherit"
            variant="h6"
          >
            Sent connection request
          </Typography>
        )}
        onClose={handleSnackbarClose}
        open={openSnackbar}
      />
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
